import type { ReactNode } from "react";

export interface ScreenBackgroundProps {
  children?: ReactNode;
  /** Z position offset for the background group (default: -10, further back) */
  zOffset?: number;
}

/**
 * CRT.Screen.Background - Container for custom background content
 *
 * Provides access to screen dimensions via useCRT() hook for child components.
 * Positions children behind the UI content layer.
 *
 * @example
 * ```tsx
 * <CRT.Screen background={
 *   <CRT.Screen.Background>
 *     <MyCustomBackground />
 *   </CRT.Screen.Background>
 * }>
 *   {content}
 * </CRT.Screen>
 * ```
 */
export function ScreenBackground({
  children,
  zOffset = -10,
}: ScreenBackgroundProps) {
  return <group position={[0, 0, zOffset]}>{children}</group>;
}

/**
 * Hook for background components to access screen dimensions
 * Re-export useCRT for convenience in background components
 */
export { useCRT as useScreenDimensions } from "../../hooks";
